import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// IMPORTANT: amplify-config must be the FIRST import — it calls Amplify.configure()
// before any other module-level code (generateClient, auth calls) can execute.
import "./amplify-config";
import ReactGA from "react-ga4";
import App from "./App.tsx";
import {
  initializeClickjackingProtection,
  monitorFrameInjection,
  setupCSPReporting,
} from "./utils/clickjackingProtection";
import "./i18n/config"; // Initialize i18n
import "./index.css";
import "./checkbox-fix.css";
import "./styles/responsive.css";

// Enable OAuth listener for handling Google sign-in redirect.
// The sign-in starts on /login but the callback goes to /app (a different route),
// so Amplify needs this explicit import to complete the OAuth code exchange.
import 'aws-amplify/auth/enable-oauth-listener';

// Initialize security protections
initializeClickjackingProtection();
monitorFrameInjection();
setupCSPReporting();

// Initialize Google Analytics 4 using react-ga4
const GA_MEASUREMENT_ID = "G-3ZC5BVTKEQ";

ReactGA.initialize(GA_MEASUREMENT_ID, {
  testMode: import.meta.env.DEV, // Enable test mode in development
});
console.log("✅ Google Analytics initialized with react-ga4");

const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
    gap: '1rem'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #007bff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <p style={{ color: '#666' }}>Loading translations...</p>
  </div>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Suspense fallback={<LoadingFallback />}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>,
);
